/** Whole-message matching preserves actual questions, including ones prefixed with "hi". */
export function isGreetingOpener(text: string): boolean {
  const normalized = text.toLowerCase().replace(/[’']/g, '').replace(/[.!?,;:]+$/g, '').replace(/\s+/g, ' ').trim();
  return /^(?:(?:hi|hello|hey)[, ]+)?(?:hi|hello|hey|lets (?:talk|chat)|(?:can we|id like to|i want to) (?:talk|chat)|what can you (?:do|help (?:me )?with)|how can you help(?: me)?|(?:can you |please )?help me|start(?: (?:chat|conversation))?)$/.test(normalized);
}
